import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import 'bootstrap/dist/js/bootstrap.bundle';
import 'slick-carousel/slick/slick';
import 'plyr';
import * as bodyScrollLock from 'body-scroll-lock';

window.bodyScrollLock = bodyScrollLock;

import 'dragscroll';
//import 'isotope-layout/dist/isotope.pkgd.min';
import Isotope from 'isotope-layout';
import 'imagesloaded';
